import React, { Component } from "react";
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form'
import { Form, FormGroup, ModalHeader, ModalBody, ModalFooter, Row, Col, Button, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import { getCreditLimitModelAtSectionData,recalculatecreditLimitAtSection } from './action'
import CreditLimitModel from '../CreditLimitModel/index';
import { setUpdatedValues,setWeightageValues } from './helper';

class CreditLimitEditSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modelData: '',
            tempModelData:''
        }
    }

    componentDidUpdate(prevProps) {

        if (this.props.initialValues !== prevProps.initialValues) {
            this.setState({
                modelData: this.props.initialValues,
            })
        }

        if (this.props.recalculatedValues !== prevProps.recalculatedValues) {           
            this.setState({
                modelData: this.props.recalculatedValues,
            })
        }
    }
    
    modelDataCallback=(value,elementName,modelId)=>{
        const tempModelData = setUpdatedValues(this.state.modelData,value,elementName,modelId)
        this.setState({
            tempModelData:tempModelData
        })
    }

    handleWeightageChange=(e,modelId)=>{
         const tempModelData = setWeightageValues(this.state.modelData,e.target.value,modelId)
         this.setState({
            tempModelData:tempModelData
        })
    }

    recalculate=(tempModelData)=>{
        this.setState({
            modelData:this.state.modelData
        })
        this.props.handleRecalculateCreditLimit(tempModelData)
    }

    cancel =()=>{
        this.props.handleSectionCreditLimitToggle()
    }

    render() {
        let weightageList = ((this.state.modelData.clmMetaData)? this.state.modelData.clmMetaData : []).map((model,index) => {
            return(
            <tbody>
            <tr key={model.creditLimitModelId}>
                <td>{model.label}</td>
                <td><input type="text" name={model.creditLimitModelId} className='form-control' onBlur={(event) => this.handleWeightageChange(event, model.creditLimitModelId)} defaultValue={model.weightage}></input></td>
            </tr>
            </tbody>
            )
        })

        let  creditLimitModelList = ((this.state.modelData.clModels) ? this.state.modelData.clModels : []).map((model,index) => {
            return ( 
                <li key={index}>
                    <h6><strong>{model.name}</strong></h6>
                    <table className="table table-bordered border-bottom-0 mb-0">
                    <thead className="header-blue">
                        <tr>
                            <th width="70%">Element Name</th>
                            <th width="30%">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <CreditLimitModel data={model.dataValues} selectOptions={this.state.modelData.additionalDetails} modelId={model.id} modelDataCallback={this.modelDataCallback}/>                             
                    </tbody>
                    </table>
                </li>  
                )
            })

        return (
            <Row>
                <ModalHeader>
                        Credit Limit Calculation
                    </ModalHeader>
                    <ModalBody>
                    <table className="table table-bordered border-bottom-0 mb-4">
                        <thead>
                            <tr>
                                <th width="50%">Rubix Credit Days Recommendation</th>
                                <th width="50%">Rubix Credit Limit Recommendation</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td> {this.state.modelData.rubixCreditPeriodDaysRecommendation} </td>
                                <td> {this.state.modelData.rubixCreditLimitRecommendationINRLacs} </td>
                            </tr>
                        </tbody>
                        </table>
                        <br/>
                        {creditLimitModelList}
                        <br/>
                        <table className="table table-bordered border-bottom-0 mb-4">
                        <thead>
                            <tr>
                            <th width="70%">Model Name</th>
                            <th width="30%">Weightage</th>
                            </tr>
                        </thead>
                        <tbody>
                            {weightageList}
                        </tbody>
                        </table> 
                    </ModalBody>
                    <ModalFooter>
                        <Row>
                            <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.recalculate(this.state.tempModelData)}> Recalculate </Button></Col>
                            <Col ><Button type="submit" color="info" size="lg" className="justify-content-center" onClick={() => this.props.handleSaveCreditLimit(this.props.recalculatedValues,this.props.initialValues)}>Save</Button></Col>
                            <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.cancel()} > Cancel </Button></Col>
                        </Row>
                    </ModalFooter>
            </Row>
        )
    }
}

CreditLimitEditSection = reduxForm({
    form: 'creditLimitEditSection', // a unique identifier for this form
    enableReinitialize: true
})(CreditLimitEditSection);

CreditLimitEditSection = connect(
    state => ({
        initialValues: state.creditLimitEditSection.creditLimitModelParams,
        recalculatedValues: state.creditLimitEditSection.recalculatecreditLimitResponse,
        savecreditLimitResponse:state.creditLimitEditSection.savecreditLimitResponse

         // pull initial values from reducer
    })
    ,{load: getCreditLimitModelAtSectionData,
    }// bind addition fields loading action creator
)(CreditLimitEditSection);

export default CreditLimitEditSection;
